// Animated Sparkles SVG Component
export const AnimatedSparkles = ({ size = 12, color = 'white' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>
      {`
        .sparkle-1 {
          animation: sparkle-pulse 1.5s ease-in-out infinite;
          transform-origin: center;
        }
        .sparkle-2 {
          animation: sparkle-pulse 1.5s ease-in-out infinite 0.3s;
          transform-origin: center;
        }
        .sparkle-3 {
          animation: sparkle-pulse 1.5s ease-in-out infinite 0.6s;
          transform-origin: center;
        }
        .sparkle-4 {
          animation: sparkle-pulse 1.5s ease-in-out infinite 0.9s;
          transform-origin: center;
        }
        .sparkle-5 {
          animation: sparkle-pulse 1.5s ease-in-out infinite 1.2s;
          transform-origin: center;
        }
        @keyframes sparkle-pulse {
          0%, 100% {
            opacity: 0.3;
            transform: scale(0.8) rotate(0deg);
          }
          50% {
            opacity: 1;
            transform: scale(1.2) rotate(180deg);
          }
        }
      `}
    </style>

    {/* Main central sparkle */}
    <path
      className="sparkle-1"
      d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
      fill={color}
    />

    {/* Small sparkles around */}
    <circle
      className="sparkle-2"
      cx="19"
      cy="5"
      r="1.5"
      fill={color}
    />

    <path
      className="sparkle-3"
      d="M6 6L6.5 7.5L8 8L6.5 8.5L6 10L5.5 8.5L4 8L5.5 7.5L6 6Z"
      fill={color}
    />

    <circle
      className="sparkle-4"
      cx="20"
      cy="16"
      r="1"
      fill={color}
    />

    <path
      className="sparkle-5"
      d="M5 16L5.5 17L6.5 17.5L5.5 18L5 19L4.5 18L3.5 17.5L4.5 17L5 16Z"
      fill={color}
    />
  </svg>
);